<template>
    <b-modal :visible="isVisible" lazy
             centered
             hide-header
             hide-footer
             no-close-on-backdrop
             ref="modalObject">
        <div class="modal-title text-center"><h2>{{ $t(modalTitle) }}</h2></div>
        <div class="modal-body text-center">{{ $t(modalDescription) }}</div>
        <div class="float-lg-right">
            <b-button  v-for="(button, index) in cancelButtons" v-bind:key="'key1'+index" class="mr-1" variant="outline-secondary" v-on:click="cancelModal(button.id)">
                <span>{{ $t(button.label) }}</span>
            </b-button>
            <b-button v-for="(button, index) in confirmButtons" v-bind:key="'key2'+index" variant="primary" v-on:click="confirmModal(button.id)">
                <span>{{ $t(button.label) }}</span>
            </b-button>
        </div>
    </b-modal>
</template>

<script>

import { mapState, mapActions } from "vuex";

export default {
  name: "mmf-confirm-modal",
  computed: {
        ...mapState({
          modalTitle: state => state.confirmationModal.showAlertModal,
          modalDescription: state => state.confirmationModal.modalDescription,
          cancelButtons: state => state.confirmationModal.cancelButtons,
            confirmButtons: state => state.confirmationModal.confirmButtons,
        isVisible: state => state.confirmationModal.isVisible
    })
  },
  data: function() {
    return {
    }
  },
  methods: {
    ...mapActions("confirmationModal", ['confirmModal', 'cancelModal'])
  }
}
</script>